var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustContainers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3352_440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9853 15.7183L20.6797 23.5319L46.1508 36.2741L61.5137 28.488L35.9853 15.7183Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6992 39.3634L46.1704 52.1844V36.2742L20.6992 23.532V39.3634Z",
    fill: "#426DB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5308 28.488V44.1949L46.168 52.1843V36.2742L61.5308 28.488Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0338 16.8225L23.1133 23.4184L46.3096 35.061L59.2789 28.488L36.0338 16.8225Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.507 30.2302L47.5547 36.8948V50.3832L60.5505 43.6298L60.507 30.2302Z",
    fill: "#426DB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.875 33.4532V47.2218L55.0749 46.6725V32.6045L53.875 33.4532Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4727 26.2786V38.3515L23.8009 39.0995V26.9762L22.4727 26.2786Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0195 27.5706V39.6435L26.3488 40.3915V28.2692L25.0195 27.5706Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5703 28.8625V40.9355L28.8985 41.6844V29.5611L27.5703 28.8625Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1172 30.1553V42.2282L31.4454 42.9762V30.8539L30.1172 30.1553Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6641 31.447V43.52L33.9923 44.2689V32.1456L32.6641 31.447Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2109 32.74V44.8129L36.5391 45.561V33.4386L35.2109 32.74Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7578 34.0317V46.1047L39.0871 46.8536V34.7303L37.7578 34.0317Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3086 35.3247V47.3976L41.6368 48.1457V36.0233L40.3086 35.3247Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8555 36.6165V48.6894L44.1837 49.4383V37.315L42.8555 36.6165Z",
    fill: "#47A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7704 24.1997L3.46484 32.0142L28.936 44.7556L44.2999 36.9694L18.7704 24.1997Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.48438 47.8447L28.9555 60.6665V44.7555L3.48438 32.0142V47.8447Z",
    fill: "#083C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.317 36.9695V52.6773L28.9531 60.6667V44.7556L44.317 36.9695Z",
    fill: "#1C5DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.82 25.304L5.89844 31.8998L29.0948 43.5425L42.0652 36.9695L18.82 25.304Z",
    fill: "#1C5DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2922 38.7126L30.3398 45.3763V58.8656L43.3346 52.1114L43.2922 38.7126Z",
    fill: "#083C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6602 41.9356V55.7033L37.8601 55.1548V41.0859L36.6602 41.9356Z",
    fill: "#1C5DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25781 34.76V46.8329L6.58707 47.581V35.4586L5.25781 34.76Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80859 36.053V48.1259L9.1368 48.8739V36.7507L7.80859 36.053Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3555 37.3447V49.4177L11.6837 50.1657V38.0433L10.3555 37.3447Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9023 38.6367V50.7097L14.2316 51.4586V39.3353L12.9023 38.6367Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4492 39.9294V52.0024L16.7774 52.7504V40.628L15.4492 39.9294Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9961 41.2214V53.2944L19.3243 54.0433V41.92L17.9961 41.2214Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.543 42.5142V54.5871L21.8712 55.3351V43.2128L20.543 42.5142Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0938 43.8062V55.8791L24.422 56.628V44.5047L23.0938 43.8062Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6406 45.0989V57.1718L26.9699 57.9198V45.7975L25.6406 45.0989Z",
    fill: "#4B86C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4082 4.33325L12.1016 12.1469L37.5727 24.8891L52.9366 17.1029L27.4082 4.33325Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1211 27.9784L37.5922 40.7994V24.8892L12.1211 12.147V27.9784Z",
    fill: "#F49E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9537 17.103V32.8099L37.5898 40.7993V24.8892L52.9537 17.103Z",
    fill: "#F8B300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4596 5.4375L14.5391 12.0334L37.7354 23.676L50.7047 17.103L27.4596 5.4375Z",
    fill: "#F8B300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9289 18.8462L38.9766 25.5098V38.9992L51.9724 32.2449L51.9289 18.8462Z",
    fill: "#F49E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2969 22.0691V35.8368L46.4958 35.2884V21.2195L45.2969 22.0691Z",
    fill: "#F8B300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8945 14.8936V26.9665L15.2227 27.7145V15.5921L13.8945 14.8936Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4453 16.1855V28.2585L17.7735 29.0074V16.8841L16.4453 16.1855Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9922 17.4783V29.5512L20.3204 30.2992V18.1769L18.9922 17.4783Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5391 18.7703V30.8432L22.8673 31.5912V19.4689L21.5391 18.7703Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0859 20.063V32.1359L25.4152 32.884V20.7607L24.0859 20.063Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6328 21.355V33.4279L27.961 34.1759V22.0536L26.6328 21.355Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1797 22.6477V34.7206L30.5079 35.4687V23.3454L29.1797 22.6477Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7305 23.9397V36.0126L33.0597 36.7607V24.6383L31.7305 23.9397Z",
    fill: "#FBC85B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2773 25.2314V37.3044L35.6055 38.0533V25.93L34.2773 25.2314Z",
    fill: "#FBC85B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3352_440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.0667,
    height: 56.3333,
    fill: "white",
    transform: "translate(3.46484 4.33325)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustContainers);
export default __webpack_public_path__ + "static/media/illust-containers.8f6d3df73407f0572cf398f58c3e718e.svg";
export { ForwardRef as ReactComponent };